"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TelemetryInitializer_js_1 = require("../src/TelemetryInitializer.js");
var TelemetryExtensionsNg4 = /** @class */ (function () {
    function TelemetryExtensionsNg4() {
    }
    TelemetryExtensionsNg4.prototype.InitializeTelemetry = function (environmentName, ikey, serviceOffering, serviceLine, service, componentName, componentId, ictoid) {
        this.appInsights = TelemetryInitializer_js_1.TelemetryInitializer(environmentName, ikey, serviceOffering, serviceLine, service, componentName, componentId, ictoid);
        return this.appInsights;
    };
    TelemetryExtensionsNg4.prototype.trackTrace = function (traceMessage, traceObject, traceSeverity) {
        return this.appInsights.trackTrace(traceMessage, traceObject, traceSeverity);
    };
    TelemetryExtensionsNg4.prototype.trackMetric = function (metricName, metricValue, prop3, prop4, prop5, prop6) {
        return this.appInsights.trackMetric(metricName, metricValue, prop3, prop4, prop5, prop6);
    };
    TelemetryExtensionsNg4.prototype.trackException = function (errorMessage, prop2, prop3, prop4, prop5) {
        return this.appInsights.trackException(errorMessage, prop2, prop3, prop4, prop5);
    };
    TelemetryExtensionsNg4.prototype.trackEvent = function (eventName, eventProperties, prop3) {
        return this.appInsights.trackEvent(eventName, eventProperties, prop3);
    };
    TelemetryExtensionsNg4.prototype.trackPageView = function (name, url, properties) {
        this.appInsights.trackPageView(name, url, properties);
    };
    TelemetryExtensionsNg4.prototype.ComponentType = function () {
        console.log('test');
        return this.appInsights.ComponentType();
    };
    TelemetryExtensionsNg4.prototype.ItEventType = function () {
        return this.appInsights.ItEventType();
    };
    TelemetryExtensionsNg4.prototype.ExtensionsConfig = function () {
        return this.appInsights.ExtensionsConfig();
    };
    TelemetryExtensionsNg4.prototype.SerializationHelper = function () {
        return this.appInsights.SerializationHelper();
    };
    TelemetryExtensionsNg4.prototype.ItTelemetryConfiguration = function () {
        return this.appInsights.ItTelemetryConfiguration();
    };
    TelemetryExtensionsNg4.prototype.BaseEvent = function () {
        return this.appInsights.BaseEvent();
    };
    TelemetryExtensionsNg4.prototype.BpmValidation = function (businessProcessName, partBValidation, properties) {
        return this.appInsights.BpmValidation(businessProcessName, partBValidation, properties);
    };
    // Feature Usage Event Related
    TelemetryExtensionsNg4.prototype.FeatureUsageEvent = function (eventName, componentType, startDateTime, endDateTime) {
        return this.appInsights.FeatureUsageEvent(eventName, componentType, startDateTime, endDateTime);
    };
    TelemetryExtensionsNg4.prototype.TrackFeatureUsageEvent = function (appInsights, eventData, properties, measurements) {
        return this.appInsights.TrackFeatureUsageEvent(appInsights, eventData, properties, measurements);
    };
    // Business Process Event Related
    TelemetryExtensionsNg4.prototype.BusinessProcessEvent = function (businessProcessName, componentType, startDateTime, endDateTime, templateType) {
        return this.appInsights.BusinessProcessEvent(businessProcessName, componentType, startDateTime, endDateTime, templateType);
    };
    TelemetryExtensionsNg4.prototype.TrackBusinessProcessEvent = function (appInsights, eventData, properties, measurements) {
        return this.appInsights.TrackBusinessProcessEvent(appInsights, eventData, properties, measurements);
    };
    // System Event Related
    TelemetryExtensionsNg4.prototype.SystemEvent = function (businessProcessName, componentType, systemMessage) {
        return this.appInsights.SystemEvent(businessProcessName, componentType, systemMessage);
    };
    TelemetryExtensionsNg4.prototype.TrackSystemEvent = function (appInsights, eventData, properties, measurements) {
        return this.appInsights.TrackSystemEvent(appInsights, eventData, properties, measurements);
    };
    // Correlation related
    TelemetryExtensionsNg4.prototype.CorrelationConstants = function () {
        return this.appInsights.CorrelationConstants();
    };
    TelemetryExtensionsNg4.prototype.SetItTelemetryConfig = function (config) {
        return this.appInsights.SetItTelemetryConfig(config);
    };
    TelemetryExtensionsNg4.prototype.SetbpmValidations = function (bpmValidations) {
        return this.appInsights.SetbpmValidations(bpmValidations);
    };
    TelemetryExtensionsNg4.prototype.AddMsitTelemetryInitializers = function (appInsights, environmentData, correlationProvider) {
        return this.appInsights.AddMsitTelemetryInitializers(appInsights, environmentData, correlationProvider);
    };
    TelemetryExtensionsNg4.prototype.AddMsitTelemetryInitializerswithSubCorrelation = function (appInsights, environmentData, correlationProvider, subCorrelationProvider) {
        return this.appInsights.AddMsitTelemetryInitializerswithSubCorrelation(appInsights, environmentData, correlationProvider, subCorrelationProvider);
    };
    return TelemetryExtensionsNg4;
}());
exports.TelemetryExtensionsNg4 = TelemetryExtensionsNg4;
